import { ChangeDetectionStrategy, Component, computed, input, Input, Signal, WritableSignal } from '@angular/core';

import {
  ApexAxisChartSeries,
  ApexChart,
  ApexDataLabels,
  ApexFill,
  ApexPlotOptions,
  ApexTitleSubtitle,
  ApexTooltip,
  ApexXAxis,
  ApexYAxis,
  NgApexchartsModule,
} from 'ng-apexcharts';
import { ChartDataSource, ChartVisualizationConfig } from '../../models';
import { TsEmptyStateComponent } from 'tsui/lib/ts-empty-state/ts-empty-state.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ChartRendererUtils } from '../../utils/chart-renderer.utils';

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  yaxis: ApexYAxis;
  xaxis: ApexXAxis;
  fill: ApexFill;
  title: ApexTitleSubtitle;
  tooltip: ApexTooltip;
};

@Component({
  selector: 'chart-renderer',
  standalone: true,
  imports: [NgApexchartsModule, TsEmptyStateComponent, MatProgressSpinnerModule],
  templateUrl: './chart-renderer.component.html',
  styleUrl: './chart-renderer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChartRendererComponent {
  @Input() loading = false;
  data = input.required<{
    dataSource: ChartDataSource;
    visualizationConfig: ChartVisualizationConfig;
  }>();

  chartOptions: Signal<Partial<ChartOptions>> = computed(() => {
    if (this.data()) {
      return ChartRendererUtils.buildChart(this.data().visualizationConfig, this.data().dataSource);
    }
  });
}
